import React, { useState } from 'react';
import classNames from 'classnames';
import { FormattedDataPoint } from './'
import Switch from 'react-switch'
import { ambient } from '@aw_products/ambient-weather-common'
import { identity, sort } from 'ramda'
const HST = ambient.HST
// import PropTypes from 'prop-types';

export default function HsThreshold ({ zone, setHst, hst = {}, editable, guideline }) {
  const [focused, setFocused] = useState(false)
  if (!zone) {
    return null
  }
  const updateAttribute = (attribute, value, fn = identity) => {
    setHst({
      ...hst,
      customGuideline: {
        zones: fn(hst.customGuideline.zones.map((t, j) => {
          if (t._id === zone._id) {
            return { ...t, [attribute]: value }
          }
          return t
        }))
      }
    })
  }
  // Use zone.color if available (custom color), otherwise lookup by label
  let color = zone.color
  if (!color) {
    const colorObj = HST.colors.find(c => c.zoneLabel === zone.label)
    if (colorObj) {
      color = '#' + colorObj.bkgndColor
    }
  }
  let thresholdValue = zone.above
  let okThresholds = guideline.zones.map(t => t.above)
  if (guideline.modifier && hst.modifier) {
    const modifier = guideline.modifier.choices.find(c => c.label === hst.modifier)
    okThresholds = okThresholds.map(t => t - modifier.offset)
    thresholdValue -= modifier.offset
  }
  return (
    <div className={classNames('threshold hs-threshold', { focused })} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}>
      {(thresholdValue > 0 || editable) && (
        <div className='line'>
          <span className='label'>Threshold (F)</span>
          {editable
            ? (
              <input
                type='text'
                className='form-control'
                value={zone.above || ''}
                onBlur={evt => {
                  updateAttribute('above', Math.round(parseFloat(evt.target.value) * 10) / 10, sort((a, b) => a.above - b.above))
                }}
                onChange={evt => {
                  updateAttribute('above', evt.target.value)
                }}
              />
              )
            : (
              <FormattedDataPoint value={thresholdValue} type='tempf' />
              )
            }
        </div>
      )}
      {!editable ? (
        <div className='line'>
          <span className='label'>Zone</span>
          <div className='flex'>
            {color && <div className='color' style={{ backgroundColor: color }} />}
            <div>{zone.label}</div>
          </div>
        </div>
      ) : (
        <>
          <div className='line zone-label-with-color'>
            <span className='label'>Zone</span>
            <div className='flex'>
              {color && <div className='color' style={{ backgroundColor: color }} />}
              <input
                type='text'
                className='form-control'
                value={zone.label || ''}
                onChange={evt => updateAttribute('label', evt.target.value)}
              />
            </div>
          </div>
          <div className='line'>
            <span className='label'>Color</span>
            <input
              type='color'
              className='form-control color-picker'
              value={color || '#808080'}
              onChange={evt => updateAttribute('color', evt.target.value)}
            />
          </div>
        </>
      )}
      {(!editable || (editable && zone.above)) && hst.enabledThresholds && (
        <div className='line'>
          <span className='label'>Enable zone alert?</span>
          <Switch
            onColor='#09a8e6'
            checked={hst.enabledThresholds.includes(thresholdValue)}
            onChange={checked => {
              const cleanEnabledThresholds = hst.enabledThresholds.filter(et => okThresholds.includes(et))
              if (checked) {
                setHst({ ...hst, enabledThresholds: [...cleanEnabledThresholds, thresholdValue] })
              } else {
                setHst({ ...hst, enabledThresholds: cleanEnabledThresholds.filter(et => et !== thresholdValue) })
              }
            }}
          />
        </div>
      )}
      <div className='mitigation line column'>
        <span className='label'>Mitigation</span>
        {editable
          ? (
            <textarea
              className='form-control'
              value={zone.mitigation || ''}
              onChange={evt => updateAttribute('mitigation', evt.target.value)}
            />
            )
          : zone.mitigation}
      </div>
      {editable && (
        <span className='bottom'>
          <a className=' glyphicon glyphicon-trash remove-threshold' onClick={() => setHst({ ...hst, customGuideline: { ...hst.customGuideline, zones: hst.customGuideline.zones.filter(t => t._id !== zone._id) } })} />
        </span>
      )}
    </div>
  )
}

HsThreshold.propTypes = {};
HsThreshold.defaultProps = {};

HsThreshold.displayName = 'HsThreshold'
